import { hideAllPoppers } from 'floating-vue';

//Plugin to close all FloatingVue poppers on Escape key press
export default {
  install(app) {
    function onKeydown(e) {
      if (e.key === "Escape") hideAllPoppers();
    }

    document.addEventListener("keydown", onKeydown);

    // optional: cleanup on app unmount
    const originalUnmount = app.unmount;
    app.unmount = function () {
      document.removeEventListener("keydown", onKeydown);
      originalUnmount.call(this);
    };
  },
};
